import { render, staticRenderFns } from "./CoreProgramCampaignSettingsCurrency.vue?vue&type=template&id=247da42c&scoped=true&"
import script from "./CoreProgramCampaignSettingsCurrency.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignSettingsCurrency.vue?vue&type=script&lang=js&"
import style0 from "./CoreProgramCampaignSettingsCurrency.vue?vue&type=style&index=0&id=247da42c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247da42c",
  null
  
)

export default component.exports